import { useCategoryTreeItem } from '../categoryTree';
import { useInfiniteQueryWithLimit } from '../hooks/useInfiniteQueryWithLimit';
import { queryKeys } from '../queryKeys';

import { fetchContinueWatching } from './fetchContinueWatching';
import type { ContinueWatchingAsset } from './types';

const DEFAULT_DAYS_SINCE_WATCHED = 50;

type UseContinueWatchingProps = {
  useLimit?: boolean;
  pageSize: number;
  referenceId: string;
};

export function useContinueWatching({ referenceId, pageSize, useLimit }: UseContinueWatchingProps) {
  const category = useCategoryTreeItem(referenceId);

  return useInfiniteQueryWithLimit<ContinueWatchingAsset>({
    queryKey: category ? queryKeys.continueWatching(referenceId, pageSize) : queryKeys.disabled,
    queryFn: ({ pageParam }) => {
      return fetchContinueWatching({
        types: category!.continueWatchingProperty.typeIn!.split(',').map(Number),
        pageSize,
        pageIndex: pageParam,
        watchingStatus: category!.continueWatchingProperty.statusEqual,
        daysSinceWatched: DEFAULT_DAYS_SINCE_WATCHED,
      });
    },
    enabled: Boolean(category),
    pageSize,
    limit: useLimit ? category?.railProperty.railItemsLimit : undefined,
  });
}
